import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEO from './SEO';
import './NotFound.css';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <>
      <SEO 
        title={t('404.title')}
        description={t('404.description')}
        noindex={true}
      />
      <div className="not-found-container">
        <div className="not-found-content">
          <h1 className="not-found-title">404</h1>
          <h2 className="not-found-subtitle">{t('404.subtitle')}</h2>
          <p className="not-found-description">{t('404.message')}</p>
          <Link to="/" className="not-found-button">
            {t('404.backHome')}
          </Link>
        </div>
        <div className="not-found-illustration">
          <img 
            src="/assets/mobile-phone.svg" 
            alt="TapTrap Phone" 
            className="not-found-phone"
          />
        </div>
      </div>
    </>
  );
};

export default NotFound;